import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Connections management route (`/integrations/connections`).
 * Super-admin only — a cross-subsidiary operational view for managing every
 * connection's lifecycle and health. Lazy-loaded to keep it off the initial
 * authenticated bundle.
 */
const ConnectionsPage = lazy(() => import('~/features/integrations/pages/connections-page'));

// Persist the page-local subsidiary scope in the URL (opaque `?sc=`) so a reload
// / shared link keeps the picked subsidiary instead of snapping to the active tenant.
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/integrations/connections/')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectionsPage />
    </Suspense>
  );
}
